import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BsEye, BsEyeSlash } from 'react-icons/bs';
import Loader from '../components/Loader';

const ResetPassword = ({ route }) => {
  const navigate = useNavigate();
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loader, setLoader] = useState(false);

  // Toast Configuration
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (password !== confirmPassword) {
      Toast.fire({
        icon: 'error',
        title: 'Passwords do not match'
      });
      return;
    }

    if (password.length < 8) {
      Toast.fire({
        icon: 'error',
        title: 'Password must be at least 8 characters long'
      });
      return;
    }

    setLoader(true);

    try {
      const response = await axios.post(`${route}/auth/reset-password`, {
        token,
        password
      });

      if (response.data.status === 'ok') {
        Toast.fire({
          icon: 'success',
          title: 'Password has been reset successfully'
        });
        navigate('/login');
      }
    } catch (error) {
      Toast.fire({
        icon: 'error',
        title: error.response?.data?.message || 'Something went wrong. Please try again.'
      });
    } finally {
      setLoader(false);
    }
  };

  return (
    <main className="login-page">
      {loader && <Loader />}
      <div className="login-wrapper">
        <form className="form_container" onSubmit={handleSubmit}>
          <div className="logo_container" onClick={() => navigate('/')}>
            <img src="/full-logo-black.png" height={33} alt="" />
          </div>
          <div className="title_container">
            <p className="titles">Reset Password</p>
            <span className="subtitle">
              Please enter your new password.
            </span>
          </div>
          <br />
          <div className="input_containers">
            <label className="input_labels" htmlFor="password_field">
              New Password
            </label>
            <svg
              fill="none"
              viewBox="0 0 24 24"
              height="24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              className="icont"
            >
              <path
                strokeLinecap="round"
                strokeWidth="1.5"
                stroke="#141B34"
                d="M18 11.0041C17.4166 9.91704 16.273 9.15775 14.9519 9.0993C13.477 9.03404 11.9788 9 10.329 9C8.67911 9 7.18091 9.03404 5.70604 9.0993C3.95328 9.17685 2.51295 10.4881 2.27882 12.1618C2.12602 13.2541 2 14.3734 2 15.5134C2 16.6534 2.12602 17.7727 2.27882 18.865C2.51295 20.5387 3.95328 21.8499 5.70604 21.9275C6.42013 21.9591 7.26041 21.9834 8 22"
              ></path>
              <path
                strokeLinejoin="round"
                strokeLinecap="round"
                strokeWidth="1.5"
                stroke="#141B34"
                d="M6 9V6.5C6 4.01472 8.01472 2 10.5 2C12.9853 2 15 4.01472 15 6.5V9"
              ></path>
            </svg>
            <input
              type={showPassword ? "text" : "password"}
              onChange={(e) => setPassword(e.target.value.trim())}
              required
              placeholder="New Password"
              title="Input title"
              name="input-name"
              className="input_field"
              id="password_field"
            />
            <div
              className="eye-container"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <BsEye /> : <BsEyeSlash />}
            </div>
          </div>

          <div className="input_containers">
            <label className="input_labels" htmlFor="confirm_password_field">
              Confirm New Password
            </label>
            <svg
              fill="none"
              viewBox="0 0 24 24"
              height="24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              className="icont"
            >
              <path
                strokeLinecap="round"
                strokeWidth="1.5"
                stroke="#141B34"
                d="M18 11.0041C17.4166 9.91704 16.273 9.15775 14.9519 9.0993C13.477 9.03404 11.9788 9 10.329 9C8.67911 9 7.18091 9.03404 5.70604 9.0993C3.95328 9.17685 2.51295 10.4881 2.27882 12.1618C2.12602 13.2541 2 14.3734 2 15.5134C2 16.6534 2.12602 17.7727 2.27882 18.865C2.51295 20.5387 3.95328 21.8499 5.70604 21.9275C6.42013 21.9591 7.26041 21.9834 8 22"
              ></path>
              <path
                strokeLinejoin="round"
                strokeLinecap="round"
                strokeWidth="1.5"
                stroke="#141B34"
                d="M6 9V6.5C6 4.01472 8.01472 2 10.5 2C12.9853 2 15 4.01472 15 6.5V9"
              ></path>
            </svg>
            <input
              type={showConfirmPassword ? "text" : "password"}
              onChange={(e) => setConfirmPassword(e.target.value.trim())}
              required
              placeholder="Confirm New Password"
              title="Input title"
              name="input-name"
              className="input_field"
              id="confirm_password_field"
            />
            <div
              className="eye-container"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
              {showConfirmPassword ? <BsEye /> : <BsEyeSlash />}
            </div>
          </div>

          <button type="submit">Reset Password</button>
          
          <Link to="/login" className="note">
            Back to Login
          </Link>
        </form>
      </div>
    </main>
  );
};

export default ResetPassword; 